import Model, { attr, hasMany } from '@ember-data/model';
import _cloneDeep from 'lodash/cloneDeep';
export default class MailerTemplate extends Model {
  // Relationships
  @hasMany('mailer-template-section') mailerTemplateSections;
  @hasMany('mailer-template-version') mailerTemplateVersions;

  // Attributes
  @attr('string') description;
  @attr('string') subject;
  @attr('string') subtitle;
  @attr('string') title;
  @attr('boolean') active;
  @attr('string') identifier;

  get mailerSectionBlocks() {
    if (!this.mailerSections) return null;
    return this.mailerSections.reduce((acc, mailerSection) => {
      return [...acc, ...mailerSection.mailerSectionBlocks.toArray()];
    }, []);
  }

  get mailerSections() {
    if (!this.mailerTemplateSections) return null;
    return this.mailerTemplateSections.mapBy('mailerSection');
  }
}
